module.exports = {
    BILL: 'bill',
    INVOICE: 'invoice',
    LEDGER_ENTRY: 'ledger_entry',
    MULTI_OBJECTS: 'multi_objects'
}
